import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { KModalService } from 'ng-k-modal';
import { GlobalLoadingService } from '../services/global-loading.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { SharedService } from '../services/shared.service';
import { OauthPlusService } from '../services/oauth-plus.service';
import { Router } from '@angular/router';
import { TimeoutService } from '../services/timeout.service';
@Injectable()
export class HandleTokenExpireInterceptor implements HttpInterceptor {

  constructor(
    // private oauthService: OAuthService,
    // private sharedService: SharedService,
    // private oauthPlusService : OauthPlusService,
    private loaderService:GlobalLoadingService,
    private modalService: KModalService,
    private timeoutService: TimeoutService
    // private router: Router
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
      return next.handle(request).pipe(catchError((e: HttpErrorResponse) => {
        if(request.url.indexOf(environment.apiUrl)>= 0){
          if(e.status == 401){
            this.loaderService.stopAllLoadingIndicator();
            if(!this.timeoutService.getTimeoutModalIsOpen() || !this.modalService.getIsOpen("renewTokenFailed")){
              this.modalService.setIsOpen("renewTokenFailed", true);
            }
            // console.log(e?.message);
            // this.oauthPlusService.setObservablesOntoken();
            // this.sharedService.setOnUserLogged(false);
            // this.oauthService.logOut();
            // localStorage.clear()
            // setTimeout(() =>this.router.navigate(['/']), 500)
          }
        }
        return throwError(() => e);
      }));
  }
}
